jQuery(document).ready(function($) {
  styleSelect.init();
  cartValidation.init();
  memberPopup.init();
  quantityInput.init();
  animatedSection.init();
  loadMorePosts.init();
  utility.init()

  require('./components/mobile-header.js')
  require('./components/accordion.js')
  require('./components/video.js')
  require('./components/search.js')
  require('./components/slider.js')

  var subscribeForm = document.querySelector('#subscribe-form')
  var successMessage = document.querySelector('.success-message')

  subscribeForm.addEventListener('submit', e => {
    e.preventDefault()

    $.ajax({
       type: "POST",
       url: "https://mymail.ezemsgs.com/em/forms/subscribe.php?db=715218&s=372705&a=39244&k=Rhx5laUnuN8naq1IbrO1eQCpomxACKAZxTb1WOu5lhI&va=5",
       // serialize your form's elements.
       data: $(subscribeForm).serialize(),
       complete: function(data)
       {
         $(subscribeForm).html('<p class="success-message">Thanks for subscribing, we will be in contact with you shortly</p>')
       }
     });
  });
});

var styleSelect = {
  init: function() {
    var selects = document.querySelectorAll('select');

    if(selects.length > 0) {
      for(var i = 0; i <= selects.length; i++){
        if(selects[i]) {
          selects[i].style.display = 'none'
          var classList = selects[i].classList
          var selectOptions = selects[i].querySelectorAll('option')
          var selectName = selects[i].name
          var selectedIndex = selects[i].selectedIndex

          if(selectOptions.length > 0)
            var optionsStart = '<ul class="select-options">'
            var optionsList = ''

            for(var x = 0; x <= selectOptions.length; x++)	{
              if(selectOptions[x]) {
                var optionContent = selectOptions[x].innerHTML
                var optionValue = selectOptions[x].value

                if(x == selectedIndex) {
                  var selectedValue = '<span class="select-rendered" data-name="'+selectName+'">'+optionContent+'</span>'

                  if(optionValue != '') {
                    optionsList = optionsList + '<li class="select-option selected" data-value="'+optionValue+'" data-name="'+selectName+'" data-index="'+x+'">'+optionContent+'</li>'
                  }
                } else {
                  optionsList = optionsList + '<li class="select-option" data-value="'+optionValue+'" data-name="'+selectName+'" data-index="'+x+'">'+optionContent+'</li>'
                }

              }
            }

            var optionsEnd = '</ul>'

          selects[i].insertAdjacentHTML('afterend', '<div class="select-dropdown '+classList+'">' + selectedValue + optionsStart + optionsList + optionsEnd + '</div>');
        }
      }

      var selectDropdown = document.querySelectorAll('.select-dropdown')

      Array.prototype.forEach.call(selectDropdown, function(currentDropdown, i){
        var selectRendered = currentDropdown.querySelectorAll('.select-rendered');
        var selectOption = currentDropdown.querySelectorAll('.select-option');


        currentDropdown.addEventListener("click", function(event){
          jQuery(this).toggleClass('dropdown-active')

        });

        document.addEventListener('click', function(event) {
          var isClickInside = currentDropdown.contains(event.target);

          if (!isClickInside) {
            jQuery(currentDropdown).removeClass('dropdown-active')
          }
        });


        Array.prototype.forEach.call(selectOption, function(el, i){
          el.addEventListener("click", function(){
            var selectOptionName = this.getAttribute('data-name')
            var selectOptionValue = this.getAttribute('data-value')
            var selectOptionIndex = this.getAttribute('data-index')
            var targetSelect = document.querySelectorAll('select[name="'+selectOptionName+'"]')
            var targetRender = document.querySelectorAll('.select-rendered[data-name="'+selectOptionName+'"]')
            var targetOptions = document.querySelectorAll('.select-option[data-name="'+selectOptionName+'"]')
            targetSelect[0].selectedIndex = selectOptionIndex
            targetRender[0].innerHTML = this.innerHTML

            var event = document.createEvent('HTMLEvents');
             event.initEvent('change', true, false);
             targetSelect[0].dispatchEvent(event);


            for(y = 0; y <= targetOptions.length; y++){
              if(targetOptions[y]) {
                if(this === targetOptions[y]) {
                  jQuery(this).addClass('selected')
                } else {
                  jQuery(targetOptions[y]).removeClass('selected')
                }
              }
            }
          });
        })
      })
    }
  }
}

var cartValidation = {
  init: function() {
    jQuery('#single-product--cart-form').on('submit', function(e) {
      var hasError = [...document.querySelectorAll('.ticket-holder input')].find(input => input.value === '')

      if(hasError) {
        e.preventDefault()

        jQuery(this).find('.ticket-holder input').each(function() {
          var input = jQuery(this)
          var emptyValue = !input.val()

          if(emptyValue) {
            input.addClass('error')
            input.attr('placeholder', 'Field is required')
          } else if( input.hasClass('error')) {
            input.removeClass('error')
          }
        })
      }
    })
  }
}

var quantityInput = {
  init: function() {
    jQuery('.product-info .quantity').each(function() {
      var input, btnUp, btnDown, min, max

      input = jQuery(this).find('input')
      btnUp = jQuery('.quantity-up')
      btnDown = jQuery('.quantity-down')
      min = input.attr('min'),
      max = input.attr('max');

      function addTicketHolder(oldVal, newVal) {
        var container = document.querySelector('.ticket-holders')

        if(oldVal < newVal) {
          var item = document.createElement('li');
          item.classList.add('ticket-holder');
          item.setAttribute('id', 'ticket-holder-' + newVal);
          var node = document.createTextNode('');

          item.appendChild(node);
          container.appendChild(item);

          var inputName = document.createElement('input');
           inputName.type = 'text';
           inputName.name = 'ticket-holder-name-' + newVal;

          var inputEmail = document.createElement('input');
           inputEmail.type = 'email';
           inputEmail.name = 'ticket-holder-email-' + newVal;

          item.appendChild(inputName);
          item.appendChild(inputEmail);


        } else if(oldVal > newVal && oldVal > 1) {
          var lastItemID = document.querySelector('#ticket-holder-' + oldVal);

          lastItemID.parentNode.removeChild(lastItemID)
        }
      }

      btnUp.click(function() {
        var oldValue = parseFloat(input.val());

        if (max && oldValue >= max) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue + 1;
        }

        input.val(newVal);
        input.trigger("change");

        addTicketHolder(oldValue, newVal)
      })

      btnDown.click(function() {
        var oldValue = parseFloat(input.val());

        if (min && oldValue <= min) {
          var newVal = oldValue;
        } else {
          var newVal = oldValue - 1;
        }

        input.val(newVal);
        input.trigger("change");

        addTicketHolder(oldValue, newVal)
      })
    })
  },
}

var memberPopup = {
  init: function() {
    jQuery('.member-thumbnail').each(function() {
      var member = jQuery(this)

      member.find('.profile-img').click(function() {
        member.children('.member-popup').addClass('active')
        jQuery('body, html').css('overflow-y', 'hidden');
      })

      jQuery('.member-popup .popup-close').click(function() {
        jQuery(this).closest('.member-popup').removeClass('active')
        jQuery('body, html').css('overflow-y', 'auto');
      })
    })
  },
}

var animatedSection = {
  init: function() {
    jQuery(window).scroll(function(event){

  	  var yOffset = window.pageYOffset;
  	  var breakpoint = 20;
  	  if (yOffset > breakpoint){
  	    jQuery("header").addClass('active');
  	  }else{
  	    jQuery("header").removeClass('active');
  	  }
  	});
  },
}

var loadMorePosts = {
  init: function() {
    jQuery('#load-more').click(function(){
        loadMorePosts.loadMore();
    });
  },

  loadMore: function() {
    var loadContainer = jQuery('#load-container');
    var postCount = jQuery('#load-container .item').length;
    var totalPosts = loadContainer.data('total');
    var args = loadContainer.data('args');

    if(postCount >= totalPosts) {
      return;
    }

    var data = {
      action: 'load_more_posts',
      post_count: postCount,
      post_args: args,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
    };

    jQuery.ajax({
      url: posts.ajaxurl,
      type: "POST",
      data: data,
      beforeSend: function () {

      // Request for posts

        jQuery('#load-more').addClass('loading');
      },
      complete: function () {

          // Request for posts received / response is being sent back to us

          jQuery('#load-more').removeClass('loading');
        },
        success: function(data) {

          // We get posts back / successful response

          if(data) {
            loadContainer.append(data);
          }

          postCount = jQuery('#load-container .item').length;

          if(postCount >= totalPosts) {
            jQuery('#load-more').replaceWith('<a class="no-posts button" href="#load-container">Back to top</a>');
          }

          utility.hashAnimate();

          return;
        }
    });
  }
}

var utility = {
  init: function() {
      utility.hashAnimate();
  },

  hashAnimate: function() {
    jQuery('a[href^="#"]').click(function(e) {
        e.preventDefault();

        var localHash = jQuery(this).attr('href');
        var scrollOffset = jQuery('header').outerHeight();

        if(jQuery(localHash).offset()) {
          jQuery("html, body").animate({
            scrollTop: jQuery(localHash).offset().top - scrollOffset - 140
          }, 200);
        }
    });
  }
}
